import React, { useState, useEffect } from "react";
import MainContent from "@components/content";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import css from './index.module.css';
import { useTranslation } from 'react-i18next';
import i18n from '@locales/index';

export default function RootPage() {
    const [available, setAvaiable] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        const savedLanguage = localStorage.getItem('selectedLanguage');
        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage);
        }
    }, []);

    return (
        <MainContent>
            <div className={css.projects} id="projects" style={{ flexDirection: 'column' }}>
                <div className={css.otherProjects}>
                    <a className={css.name}>Юридическая практика</a>
                    <span className={css.desc}>Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.</span>
                    <div className={`${css.prHeader} dev-hidden-mobile`}>
                        <span className={css.colTitle}>Название</span>
                        <span className={css.colTitle}>Вид спора</span>
                        <span className={css.colTitle}>Лица</span>
                        <span className={css.colTitle}>Год</span>
                        <span className={css.colTitle}>Статус</span>
                    </div>

                    <Link className={css.prItem} to={`/legal/1`} target="_blank" rel="noreferrer">
                        <a className={css.prName}><i className={`fi fi-rr-bolt ${css.boltIcon}`} /> Отказ в выдаче заграничного паспорта</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Федеральное законодательство</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>Суд (кассация), МВД, Прокуратура</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2025 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.whiteCircle} data-tooltip='В производстве' />
                        </div>
                    </Link>
                    <Link className={css.prItem} to={`/legal/6`} target="_blank" rel="noreferrer">
                        <a className={css.prName}><i className={`fi fi-rr-bolt ${css.boltIcon}`} /> Блокировка ресурсов в сети Интернет</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Федеральное законодательство</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>Суд (апелляция), Роскомнадзор, ФГУП «ГРЧЦ», ООО "Т-Моб", Генпрокуратура России, Минцифры России</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2026 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.whiteCircle} data-tooltip='В производстве' />
                        </div>
                    </Link>
                    <Link className={css.prItem} to={`/legal/5`} target="_blank" rel="noreferrer">
                        <a className={css.prName}>Блокировка ЕСИА и мессенджер «МАХ»</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Федеральное законодательство</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>Генпрокуратура России, Минцифры России, ФАС России</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2026 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.greenCircle} data-tooltip='Дело закрыто' />
                        </div>
                    </Link>

                    <Link className={css.prItem} to={`#`} target="_blank" rel="noreferrer">
                        <a className={css.prName}>Ущерб от некачественной электроэнергии</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Энергоснабжение и ЖКХ</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>ПАО «Россети»</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2026 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.greenCircle} data-tooltip='Дело закрыто' />
                        </div>
                    </Link>
                    <Link className={css.prItem} to={`#`} target="_blank" rel="noreferrer">
                        <a className={css.prName}>Нарушение условий благоустройства участка</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Защита прав потребителей</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>Индивидуальный предприниматель</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2026 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.greenCircle} data-tooltip='Заключено мировое соглашение' />
                        </div>
                    </Link>
                    <Link className={css.prItem} to={`/legal/4`} target="_blank" rel="noreferrer">
                        <a className={css.prName}>«MAX» в образовательных учреждениях</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Права несовершеннолетних</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>Министерство Просвещения России</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2026 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.greenCircle} data-tooltip='Дело закрыто' />
                        </div>
                    </Link>
                    <Link className={css.prItem} to={`/legal/3`} target="_blank" rel="noreferrer">
                        <a className={css.prName}>Разъяснение блокировки CloudFlare</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Федеральное законодательство</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>Роскомнадзор</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2025 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.greenCircle} data-tooltip='Дело закрыто' />
                        </div>
                    </Link>
                    <Link className={css.prItem} to={`/legal/2`} target="_blank" rel="noreferrer">
                        <a className={css.prName}>Запрет видеофиксации в отделении МВД</a>
                        <a className={`${css.prWork} dev-hidden-mobile`}>Федеральное законодательство</a>
                        <a className={`${css.prType} dev-hidden-mobile`}>МВД, Прокуратура</a>
                        <a className={`${css.prDate} dev-hidden-mobile`}>2025 г.</a>
                        <div className={`${css.prStatus} dev-hidden-mobile`}>
                            <section className={css.greenCircle} data-tooltip='Дело закрыто' />
                        </div>
                    </Link>
                </div>
            </div>

        </MainContent>
    )
}